import { CLIENT_LOGOS } from "@/lib/clients";

export const ClientLogos = () => {
  if (!CLIENT_LOGOS.length) return null;
  const row = [...CLIENT_LOGOS, ...CLIENT_LOGOS, ...CLIENT_LOGOS];
  return (
    <section className="border-y border-[#0B2A6F]/10 bg-white py-12" data-testid="client-logos-section">
      <p className="px-4 text-center font-display text-lg font-bold text-[#050B1F] sm:text-xl">Businesses power their payments with 866Zerofees.com</p>
      <div className="relative mt-8 overflow-hidden [mask-image:linear-gradient(90deg,transparent,#000_10%,#000_90%,transparent)]">
        <div className="marquee-track flex w-max items-center gap-16">
          {[0, 1].map((k) => (
            <div key={k} className="flex shrink-0 items-center gap-16" aria-hidden={k === 1}>
              {row.map((c, i) => (
                <img key={`${k}-${i}`} src={c.src} alt={k === 0 ? c.name : ""} data-testid={k === 0 && i < CLIENT_LOGOS.length ? `client-logo-${i}` : undefined}
                  className="h-10 w-auto max-w-[160px] object-contain opacity-70 grayscale transition-[filter,opacity] duration-300 hover:opacity-100 hover:grayscale-0 sm:h-12" />
              ))}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
